import React from 'react';
import {
  FULL_ABEL,
  FULL_CELIA_YUNIOR,
  FULL_CRISTINA,
  FULL_FIDEL_GARCIA,
  FULL_HENRI_ERIC,
  FULL_HUMBERTO_DIAZ,
  FULL_JAVIER_CASTRO,
  FULL_JORGE_RODRIGUEZ,
  FULL_LUIS_MANUEL,
  FULL_MAGALY_ESPINOSA,
  FULL_MOSQUERA,
  FULL_NESTOR,
  FULL_REYNIER_LEYVA,
  FULL_RODOLFO_PERAZA,
  FULL_SANDRA_CEBALLOS,
  FULL_SANDRA_RAMOS,
  FULL_TANYA,
  FULL_TOIRAC,
  FULL_YANELIS,
} from '../constants';

const Creditos = () => (
  <div style={{ textAlign: 'center' }}>
    <h2>CRÉDITOS</h2>
    <p>
      Una producción de AURA en coproducción con el Laboratorio Iberoamericano
      de Documental
    </p>
    <p>Producción ejecutiva de Open Society Foundations y AURA.</p>

    <h3>WEBDOCUMENTAL</h3>
    <ul>
      <li>
        <b>Dirección:</b> Pablo Martínez-Zárate
      </li>
      <li>
        <b>Diseño:</b> José Luis Rangel
      </li>
      <li>
        <b>Programación:</b> Zac Parker
      </li>
      <li>
        <b>Ilustración:</b> Omar Soto Martínez
      </li>
      <li>
        <b>Edición:</b> Renata Arzac
      </li>
    </ul>

    <h3>PELÍCULA</h3>
    <ul>
      <li>
        <b>Dirección y producción:</b> Isabel Gil
      </li>
      <li>
        <b>Guión:</b> Yissel Arce, Isabel Gil, Luis Vargas, Andrea Villers y
        Pablo Martínez-Zárate
      </li>
      <li>
        <b>Codirección y dirección de arte:</b> Pablo Martínez-Zárate
      </li>
      <li>
        <b>Coordinación de investigación:</b> Yissel Arce
      </li>
      <li>
        <b>Asesoría de investigación:</b> Luis Vargas, Andrea Villers y
        Maricarmen Martínez.
      </li>
      <li>
        <b>Fotografía:</b> Pablo Martínez-Zárate y Pablo Acevedo
      </li>
      <li>
        <b>Producción en Cuba:</b> Talía Bustamante
      </li>
      <li>
        <b>Asistente de producción:</b> Andrea Villers
      </li>
      <li>
        <b>Sonido:</b> Pablo Acevedo
      </li>
      <li>
        <b>Edición:</b> Marina Viruete
      </li>
    </ul>

    <h3>ENTREVISTADOS</h3>

    <ul>
      <li>{FULL_ABEL}</li>
      <li>{FULL_SANDRA_RAMOS}</li>
      <li>{FULL_RODOLFO_PERAZA}</li>
      <li>{FULL_FIDEL_GARCIA}</li>
      <li>{FULL_CRISTINA}</li>
      <li>{FULL_JAVIER_CASTRO}</li>
      <li>{FULL_NESTOR}</li>
      <li>{FULL_SANDRA_CEBALLOS}</li>
      <li>{FULL_MAGALY_ESPINOSA}</li>
      <li>{FULL_JORGE_RODRIGUEZ}</li>
      <li>{FULL_HUMBERTO_DIAZ}</li>
      <li>{FULL_TOIRAC}</li>
      <li>{FULL_CELIA_YUNIOR}</li>
      <li>{FULL_REYNIER_LEYVA}</li>
      <li>{FULL_TANYA}</li>
      <li>{FULL_YANELIS}</li>
      <li>{FULL_LUIS_MANUEL}</li>
      <li>{FULL_HENRI_ERIC}</li>
      <li>{FULL_MOSQUERA}</li>
    </ul>

    <h3>AGRADECIMIENTOS</h3>

    <ul>
      <li>Suset Sánchez</li>
      <li>Diana Cuéllar Ledesma</li>
      <li>Héctor Fernández de Lara</li>
      <li>Silverio Orduña Cruz</li>
    </ul>
  </div>
);
export default Creditos;
